import styled from 'styled-components';
import { cssVars } from '@/styles/Themes/cssVars';
import Text from '@/styles/Themes/Text';
import Screen from '@/styles/Themes/Screen';

export const ActivityDescription = styled.div`
    width: 100%;
    margin: 20px 0 30px;

    ${Screen.ipad} {
        margin: 21px 0 37px;
    }

    ${Screen.desktop} {
        max-width: 1064px;
        margin: 15px 0 40px;
    }
`;

export const Partner = styled.div`
    display: flex;
    ${Text.Full.large.regular};
    color: ${cssVars.fg_gray2_gray3};
    margin: 10px 0;

    ${Screen.desktop} {
        margin: 15px 0 10px;
    }

    > span {
        color: ${cssVars.fg_black_white};
    }
`;

export const Duration = styled.span`
    display: flex;
    align-items: center;
    ${Text.Full.large.regular};
    color: ${cssVars.fg_gray2_gray3};
    margin: 10px 0;
`;
